import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { Column, EnhancedAutocomplete, Spinner, Typography, useOverlayContext } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { ManageContactModalForVendor } from '~/components/ManageContactModal';
import { useContacts } from '~/hooks/reactQuery/queries/useContacts';
import { useLocaleKeys } from '~/i18n';
import { toContactOption } from './BillContactPicker.utils';
export const GetBillContactPickerTID = ()=>getTestIds({
        deprecatedTestIds: {
            BillContactPickerTestIds: {
                Picker: 'global-bill-modal-contacts-picker'
            }
        }
    });
export const BillContactPicker = (param)=>{
    let { onChange, error, helperText, disabled, selectedContactId } = param;
    var _options_find;
    const { BillContactPickerTestIds } = useMemo(()=>GetBillContactPickerTID(), []);
    const { t: contactsSelectorTexts } = useLocaleKeys('components.contactsSelector');
    const overlayContext = useOverlayContext();
    const { contacts, error: contactsError, isLoading, refresh: fetchContacts } = useContacts({
        refreshOnMount: true
    });
    const options = contacts.filter((c)=>!c.isSample() && c.isActive()).map(toContactOption);
    const selectedOption = (_options_find = options.find((o)=>o.id === selectedContactId)) !== null && _options_find !== void 0 ? _options_find : null;
    useEffect(()=>{
        if (contactsError !== null) {
            overlayContext.showErrorToast(contactsSelectorTexts.failedToLoadContacts(), 'contacts-error-request-toast');
        }
    }, [
        contactsError,
        contactsSelectorTexts,
        overlayContext
    ]);
    async function openContactModal(props) {
        return overlayContext.showModal({
            biName: 'manage_contact_modal_for_vendor_modal',
            closeOnEscapeKey: false,
            closeOnClickOutside: false,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(ManageContactModalForVendor, _object_spread_props(_object_spread({}, props), {
                    onClose: dismissModal,
                    origin: "Global bill modal"
                }));
            }
        });
    }
    if (isLoading) {
        return /*#__PURE__*/ _jsx(Spinner, {
            centeredInBox: true,
            size: 40,
            centerBoxHeight: 48
        });
    }
    return /*#__PURE__*/ _jsx(EnhancedAutocomplete, {
        bi: {
            name: 'contact_picker'
        },
        testId: BillContactPickerTestIds.Picker(),
        options: options,
        keyField: "id",
        labelField: "label",
        size: "medium",
        selectedOption: selectedOption,
        disabled: disabled,
        error: error,
        helperText: helperText,
        emptySearchText: contactsSelectorTexts.noOptionsText(),
        getFilterText: (option)=>"".concat(option.name, " ").concat(option.companyName, " ").concat(option.email),
        textFieldProps: {
            bi: {
                name: 'contact_picker_name'
            },
            label: contactsSelectorTexts.label(),
            placeholder: contactsSelectorTexts.placeholder()
        },
        itemRenderer: (option)=>/*#__PURE__*/ _jsxs(Column, {
                gap: 2,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        as: "p",
                        ellipsis: true,
                        children: option.companyName
                    }),
                    /*#__PURE__*/ _jsxs(Typography, {
                        as: "p",
                        skin: "secondary",
                        variant: "paragraph2",
                        ellipsis: true,
                        children: [
                            option.name,
                            " (",
                            option.email,
                            ")"
                        ]
                    })
                ]
            }),
        applyOptionChange: (option)=>{
            var _ref;
            return onChange((_ref = option === null || option === void 0 ? void 0 : option.id) !== null && _ref !== void 0 ? _ref : null);
        },
        newItemOption: {
            text: contactsSelectorTexts.createNew(),
            onClick: async ()=>{
                const savedContact = await openContactModal({});
                if (!savedContact) return;
                const { data: refreshedContacts } = await fetchContacts();
                const created = refreshedContacts === null || refreshedContacts === void 0 ? void 0 : refreshedContacts.find((c)=>c.id() === savedContact.id);
                return created && toContactOption(created);
            }
        }
    });
};
